import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import it from "./locales/it.json";
import en from "./locales/en.json";

const STORAGE_KEY = "spectraloom_lang";

export const SUPPORTED_LANGS = ["en", "it"];

export function getSavedLang() {
  // Priority order (highest first):
  //   1. `?lang=` query parameter — lets Google's crawler and hreflang
  //      variants resolve to the requested language deterministically.
  //   2. localStorage — the user's explicit choice via the header switch.
  //   3. Browser language — first-visit default.
  //   4. Italian — product-wide fallback.
  try {
    const params = new URLSearchParams(window.location.search);
    const q = (params.get("lang") || "").toLowerCase();
    if (SUPPORTED_LANGS.includes(q)) return q;
  } catch {
    /* ignore */
  }
  try {
    const l = localStorage.getItem(STORAGE_KEY);
    if (l && SUPPORTED_LANGS.includes(l)) return l;
  } catch {
    /* ignore */
  }
  // First visit: honour the user's browser language. `navigator.language`
  // looks like "it-IT" / "en-US" / "en" — we only care about the primary
  // subtag. Anything we don't ship falls back to Italian (product default).
  try {
    const raw =
      (navigator.languages && navigator.languages[0]) ||
      navigator.language ||
      "";
    const primary = String(raw).toLowerCase().split(/[-_]/)[0];
    if (SUPPORTED_LANGS.includes(primary)) return primary;
  } catch {
    /* ignore */
  }
  return "it";
}

export function setSavedLang(lang) {
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    /* ignore */
  }
}

i18n.use(initReactI18next).init({
  resources: {
    it: { translation: it },
    en: { translation: en },
  },
  lng: getSavedLang(),
  fallbackLng: "it",
  interpolation: { escapeValue: false },
  returnObjects: true,
});

// Always mirror the current language into localStorage so a refresh keeps it.
// This guards against callers that forget to call setSavedLang explicitly.
i18n.on("languageChanged", (lng) => {
  if (SUPPORTED_LANGS.includes(lng)) setSavedLang(lng);
});

export default i18n;
